import UserDefineArchives from './UserDefineArchives';
export default UserDefineArchives;





// WEBPACK FOOTER //
// ./src/common/components/UserDefineArchives/index.jsx